export function IntroductionSection() {
  return (
    <>
      <h2>DHI MetOcean Data Portal</h2>
      <p>Enhance workflows with access to accurate hindcast metocean data</p>
      <p>
        <a
          href="https://www.dhigroup.com/data-portals/metocean-data-portal"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dhigroup.com/data-portals/metocean-data-portal
        </a>
      </p>
    </>
  );
}
